module.exports = __webpack_public_path__ + "img/price-2.d90f123f.png";